(() => {
  const sources = document.currentScript.dataset;
  const pending = new Map();
  const selector = '.js-anim-typewriter, .js-anim-rolling, .js-anim-appearing';

  const load = (name) => {
    if (pending.has(name)) return pending.get(name);
    const request = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = sources[name];
      script.async = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error('Unable to load ' + name));
      document.head.appendChild(script);
    });
    pending.set(name, request);
    return request;
  };

  const initialize = async () => {
    if (document.querySelector('.popup')) {
      load('popup').catch((error) => console.error(error));
    }

    const titles = Array.from(document.querySelectorAll(selector));
    if (!titles.length) return;

    try {
      const dependencies = [];
      if (document.querySelector('.js-anim-typewriter')) dependencies.push(load('typewriter'));
      if (document.querySelector('.js-anim-rolling, .js-anim-appearing')) dependencies.push(load('gsap'));
      await Promise.all(dependencies);
      await load('titles');
    } catch (error) {
      titles.forEach((title) => { title.style.opacity = '1'; });
      console.error(error);
    }
  };

  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
